import Rete from "rete";
import { StringSocket, StringControl } from "../rete-controls/StringControl.js";
import { StatsOperationSocket } from "../rete-controls/StatsOperationControl.js";
import { NumberSocket } from "../rete-controls/NumberControl.js";
import { ArraySocket } from "../../Utils/CommonSockets.js";
import Calc from "../../Utils/Calculator.js";

export default class StatisticsComponent extends Rete.Component {
  constructor() {
    super("Statistics"); // name
    this._calc = new Calc();
    this._categories = ["Statistics Nodes", "tryMe"];
  }

  builder(node) {
    let inp1 = new Rete.Input("in1", "string", StringSocket);
    let inp2 = new Rete.Input("in2", "arr", ArraySocket);
    let inp3 = new Rete.Input("in3", "op", StatsOperationSocket);

    let out1 = new Rete.Output("out1", "OUT", NumberSocket);
    let strControl1 = new StringControl(this.editor, "display1", true);

    return node
      .addInput(inp1)
      .addInput(inp2)
      .addInput(inp3)
      .addOutput(out1)
      .addControl(strControl1);
  }

  worker(node, inputs, outputs) {
    let in1 = inputs["in1"][0];
    let in2 = inputs["in2"][0];
    let op = inputs["in3"][0];
    let arrayValue = [];

    let isString = false;
    if (in2 != [] && in2 !== undefined) {
      arrayValue = in2;
    } else if(in1 != [] && in1 !== undefined) {
      isString = true;
      arrayValue = in1.string;
    }else{
      return;
    }
    //console.log("value=" + arrayValue);
    //show the input
    if (arrayValue.length !== 0 &&
      arrayValue !== undefined &&
      arrayValue != []
    ) {
      this.editor.nodes
        .find(n => n.id == node.id)
        .controls.get("display1")
        .setValue(arrayValue);
    }

    //parse the string to array of numbers
    var myArray = [];
    if (isString) {
      myArray = arrayValue.split(",");
      for (var i = 0; i < myArray.length; i++) {
        myArray[i] = +myArray[i];
      }
    } else {
      myArray = arrayValue;
    }
    //pass the array into the maths
    if (myArray.length !== 0) {
      outputs["out1"] = this._calc.doStatsMath(op, myArray);
    }
  }
}
